import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { LanguageAndSkills } from './language-and-skills';
export { LanguageAndSkills };
import { languageAndSkillsSchema } from '@schemas/business-objects/language-and-skills';
import { CandidateFormGroup } from './candidate-form-group';

export class LanguageAndSkillsFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    azerbaijaniLevel: SchemaFormControl;
    englishLevel: SchemaFormControl;
    arabicLevel: SchemaFormControl;
    firstAidCertificate: SchemaFormControl;
    behavioralResponse: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<LanguageAndSkills>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(languageAndSkillsSchema, LanguageAndSkills, data, options);
  }

  get object(): LanguageAndSkills {
    return new LanguageAndSkills(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class LanguageAndSkillsFormArray extends PersistedFormArray {
  readonly entityName = 'LanguageAndSkills' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(languageAndSkillsSchema, LanguageAndSkills, options);
  }

  protected override createItemGroup() {
    return new LanguageAndSkillsFormGroup();
  }

  get array(): LanguageAndSkills[] {
    return this.controls.map(
      (group: LanguageAndSkillsFormGroup) => group.object,
    );
  }
}

export class LanguageAndSkillsPersistedArray extends PersistedArray<LanguageAndSkills> {
  readonly entityName = 'LanguageAndSkills' as const;

  constructor(options?: PersistedArrayOptions) {
    super(LanguageAndSkills, options);
  }
}
